import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer id="contact" className="bg-slate-950 border-t border-slate-800 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="/logo.png" 
                alt="RainXpress Logo" 
                className="h-12 w-12 rounded-full object-cover"
              />
            </div>
            <p className="text-slate-400 text-sm mb-4">
              Melbourne Mobile Car Detailing.
            </p>
            <p className="text-xs text-slate-500">
              We may take before and after photos for quality control and marketing. 
              License plates and personal details will not be displayed without permission.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <div className="space-y-3">
              <a href="tel:0478054648" className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition">
                <Phone className="w-4 h-4" />
                0478 054 648
              </a>
              <a href="mailto:hello.rainxpress@gmail.com" className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition">
                <Mail className="w-4 h-4" />
                hello.rainxpress@gmail.com
              </a>
              <div className="flex items-center gap-2 text-slate-400">
                <MapPin className="w-4 h-4" />
                Thomastown, VIC
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#packages" className="block text-slate-400 hover:text-cyan-400 transition">Packages</a>
              <a href="#service-areas" className="block text-slate-400 hover:text-cyan-400 transition">Service Areas</a>
              <a href="#policies-section" className="block text-slate-400 hover:text-cyan-400 transition">Policies</a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} RainXpress. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
